var React = require('react');

function RadioChecked (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12Z","key":0}),React.createElement("path",{"fill":"white","d":"M15.1,8.83a.89.89,0,0,1,.68-.29,1,1,0,0,1,.66.27,1,1,0,0,1,.28.66.91.91,0,0,1-.25.66l-5,6.3a.77.77,0,0,1-.31.22.92.92,0,0,1-.37.09,1,1,0,0,1-.37-.07,1,1,0,0,1-.31-.21L6.73,13.12a.84.84,0,0,1-.22-.31,1,1,0,0,1-.09-.37.94.94,0,0,1,.07-.37,1,1,0,0,1,.21-.32.83.83,0,0,1,.32-.2.77.77,0,0,1,.37-.07,1,1,0,0,1,.37.08.81.81,0,0,1,.3.22l2.65,2.64S13.38,11,15.1,8.83Z","key":1})]);
}

RadioChecked.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = RadioChecked;

RadioChecked.default = RadioChecked;
